<div class="sidebar-panel" [ngClass]="{ open: isOpen, wide: wideSidebar }">
  <div class="sidebar-panel-header">
    @if (showBackButton) {
      <div class="back">
        <sui-button
          size="sm"
          variant="secondary"
          [leadingIcon]="['fas', 'chevron-left']"
          (click)="back()"
        >
          {{ "sidebar-panel.button.back" | translate }}
        </sui-button>
      </div>
    }
    @if (!showBackButton) {
      <div class="icon">
        @if (icon) {
          <fa-icon class="icon" [icon]="icon"></fa-icon>
        }
      </div>
    }
    <h4>{{ title }}</h4>
    <fa-icon
      class="close-button"
      [icon]="['fas', 'times-circle']"
      (click)="closeSidebar()"
    ></fa-icon>
  </div>

  <!-- Boundary marker: overlays opened inside the panel mount here instead of
  <body>, so they share the panel's stacking context - same treatment as dialog
  content panes. The panel toggles open like a dialog, so it needs the same scoping. -->
  <div
    class="sidebar-panel-content"
    [class.no-toolbar]="buttons.length == 0 || !buttons || hideButtons"
    data-sui-popover-boundary
  >
    <ng-template #panelContainer></ng-template>
  </div>

  @if (buttons.length > 0 && !hideButtons) {
    <div class="sidebar-panel-footer">
      <app-panel-toolbar [buttons]="buttons"></app-panel-toolbar>
    </div>
  }
</div>
